import { FC } from 'react';
import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { TagList } from 'core/components/JianDetail/PatientDetailInfo/common/TagList';
import { IncidentDetailPatientForSendai } from '../useIncidentDetailForSendai';

type Props = {
  baseInfo: IncidentDetailPatientForSendai['baseInfo'];
};

export const CollaborationActivityView: FC<Props> = ({ baseInfo }) => {
  const data = baseInfo?.collaborationData;

  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="連携活動" />

        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="消防隊出動"
            content={data?.isFirefightingTeamDispatched ?? ''}
          />
          <InfoDisplay
            title="隊名"
            content={data?.firefightingTeamName ?? ''}
          />
        </div>

        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="消防隊到着"
            content={data?.firefightingTeamArrivalAt ?? ''}
          />
          <InfoDisplay
            title="消防隊連絡"
            content={data?.firefightingTeamContactAt ?? ''}
          />
        </div>

        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="消防隊CPR開始"
            content={data?.firefightingTeamCprStartedAt ?? ''}
          />
          <InfoDisplay
            title="救急隊CPR開始"
            content={data?.emsTeamCprStartedAt ?? ''}
          />
        </div>

        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="高度救命処置隊出動" content={data?.isAls ?? ''} />
          <InfoDisplay
            title="高度救命処置隊会議"
            content={data?.alsArrivalAt ?? ''}
          />
        </div>

        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="救急活動" content="" />
          <InfoDisplay title="救急活動期間" content="" />
        </div>

        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="連携活動等(出場運用) 主"
            content={baseInfo.collaborationOthers1}
          />
          <InfoDisplay
            title="連携活動等(出場運用) 副"
            content={baseInfo.collaborationOthers2}
          />
          <InfoDisplay
            title="ヘリ要請時期"
            content={data?.drHeliRequestedTiming ?? ''}
          />
        </div>

        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="特異救急事案"
            content={
              data?.collaborationEmergencyNo &&
              data.collaborationEmergencyNo.length > 0 ? (
                <TagList
                  tags={data.collaborationEmergencyNo.map(no => String(no))}
                />
              ) : (
                ''
              )
            }
          />
        </div>

        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="緊急連絡シート"
            content={data?.hasCollaborationCommunicationSheet ?? ''}
          />
          <InfoDisplay title="医師との連絡" content="" />
          <InfoDisplay
            title="救急車への同乗"
            content={data?.isAccompanying ?? ''}
          />
        </div>

        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="連携医師名"
            content={data?.collaborationDoctorName ?? ''}
          />
        </div>

        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="連携内容" content="" />
        </div>
      </div>
    </BorderedContainer>
  );
};
